//extracted by mini-css-extract-plugin
export default {"page":"ScReferral_page__fyW4g","inputFieldContainer":"ScReferral_inputFieldContainer__rPFyT","fieldSet":"ScReferral_fieldSet__wmaX9","legend":"ScReferral_legend__G9HBO"};;